import React from 'react';
import { Button, Dropdown, Spinner } from 'react-bootstrap';

import { useGetInvestigations_Query } from '../queries/queries';
import { CreateInvestigationModalDropdownItem } from './CreateInvestigationModal';

import useInvestigationStore from 'blockscope/components/investigations/InvestigationStore';

const InvestigationNavDropdown = () => {
  const { data, isLoading, error } = useGetInvestigations_Query();
  const {
    currentInvestigation: selectedInvestigation,
    removeCurrentInvestigation,
    setCurrentInvestigation,
  } = useInvestigationStore();

  if (isLoading) {
    return <Spinner animation='border' role='status' size='sm' />;
  }

  if (error) {
    return <div className='text-danger small'>Failed to load</div>;
  }

  const options =
    data?.map((investigation) => ({
      value: investigation._id,
      label: investigation.name,
    })) || [];

  const selectedLabel =
    options.find((option) => option.value === selectedInvestigation)?.label ||
    'Select Investigation';

  // Set dropdown width based on whether there are investigations
  const dropdownWidth = options.length > 0 ? '180px' : '280px';

  return (
    <div className='d-grid gap-2 ms-2 me-2'>
      <Dropdown>
        <Dropdown.Toggle
          as={Button}
          size='sm'
          className='btn-light text-truncate'
          style={{ width: '180px' }}
        >
          {selectedLabel}
        </Dropdown.Toggle>

        <Dropdown.Menu
          align='end'
          className='dropdown-caret dropdown-menu-card me-2'
          style={{
            maxHeight: '250px',
            overflowY: 'auto',
            width: dropdownWidth,
          }}
        >
          <div className='bg-white rounded-2 py-2 dark__bg-1000'>
            {/* Only show instructions when no investigations exist */}
            {options.length === 0 && (
              <>
                <div className='px-3 py-1 text-muted small'>
                  <em>
                    Select an investigation or create a new one. All your memos,
                    searches and notes will be saved as part of the
                    investigation.
                  </em>
                </div>
                <Dropdown.Divider />
              </>
            )}

            {options.length > 0 ? (
              <>
                {options.map((option) => (
                  <Dropdown.Item
                    key={option.value}
                    active={option.value === selectedInvestigation}
                    onClick={() => {
                      setCurrentInvestigation(option.value, option.label);
                    }}
                    className='text-truncate'
                    title={option.label}
                  >
                    {option.label}
                  </Dropdown.Item>
                ))}
                {selectedInvestigation ? (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      onClick={removeCurrentInvestigation}
                      className='text-danger'
                    >
                      Clear Selection
                    </Dropdown.Item>
                  </>
                ) : null}
                <Dropdown.Divider />
                <CreateInvestigationModalDropdownItem />
              </>
            ) : (
              <CreateInvestigationModalDropdownItem />
            )}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default InvestigationNavDropdown;
